var exports = {
  "MT": "DesktopSettingsView.module__searchContainer___a1hmc0",
  "FY": "DesktopSettingsView.module__backButtonContainer___a1hmc0",
  "j2": "DesktopSettingsView.module__backIcon___a1hmc0",
  "wV": "DesktopSettingsView.module__noResults___a1hmc0",
  "Gn": "DesktopSettingsView.module__tabLabel___a1hmc0",
  "fC": "DesktopSettingsView.module__badgeContainer___a1hmc0",
  "tM": "DesktopSettingsView.module__sectionLabelWithBadge___a1hmc0",
  "bS": "DesktopSettingsView.module__legalLinks___a1hmc0",
  "z8": "DesktopSettingsView.module__footerContent___a1hmc0",
  "el": "DesktopSettingsView.module__legalLink___a1hmc0",
  "Ic": "DesktopSettingsView.module__footerSpacer___a1hmc0",
  "Ij": "DesktopSettingsView.module__fullWidth___a1hmc0",
  "QM": "DesktopSettingsView.module__breadcrumbTitle___a1hmc0",
  "Yr": "DesktopSettingsView.module__breadcrumbButton___a1hmc0",
  "BV": "DesktopSettingsView.module__breadcrumbChevron___a1hmc0",
  "rV": "DesktopSettingsView.module__breadcrumbCurrent___a1hmc0",
};

module.exports = exports;
